<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista para consultar los prestamos de autos
    * Autor: Omar Enrique Ramos Gonzalez
    * F.Creación: Enero 2024
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <!-- caja de texto para buscar informacion en tabla de contenido -->
      <v-text-field
        solo
        class="mt-4"
        :label="$t('headerSearch')"
        prepend-inner-icon="mdi-text-search-variant"
        v-model="search"
      ></v-text-field>
      <!-- Tabla de contenido -->
      <v-data-table
        :headers="headers"
        :items="formatDataRequests"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
      >
        <template v-slot:top>
          <v-toolbar flat color="primary" :dark="true">
            <v-toolbar-title class="white--text">{{$t('tblTitle')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- Selector de rango de fechas -->
            <v-menu
              ref="menuDate"
              v-model="menuDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ma-2"
                  outlined
                  color="white"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-calendar</v-icon>
                  {{dateRangeText}}
                </v-btn>
              </template>
              <v-date-picker
                v-model="dates"
                scrollable
                range
                color="primary"
                min="2024-01-22"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menuDate = false"
                >
                  {{$t('close-action')}}
                </v-btn>
              </v-date-picker>
            </v-menu>
            <!-- Export de datos -->
            <vue-json-to-csv
              :json-data="formatDataRequests"
              :labels="reportLables"
              :csv-title="'TSMXDigital_CarReport_' + dates.join('_')"
            >
              <v-btn
                class="ma-2"
                outlined
                color="white"
                v-bind="attrs"
                v-on="on"
                :disabled="requests.length < 2"
              >
                <v-icon left>mdi-export-variant</v-icon>
                Export
              </v-btn>
            </vue-json-to-csv>
          </v-toolbar>
        </template>
      </v-data-table>
      <!-- snackbar de mensajes -->
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">{{$t('close-action')}}</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
// Incluimos el LAYOUT estandar para los usuario que ya tienen
// una sesión activa
import Layout from "@/components/Layouts/company";
// Incluimos los mensajes de esta pantalla
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import VueJsonToCsv from 'vue-json-to-csv'
// import _ from "lodash";

export default {
  // Se definen los componentes requeridos por esta pantalla
  components: {
    layout: Layout,
    vueJsonToCsv: VueJsonToCsv
  },
  i18n: i18nMessages,
  data: function() {
    return {
      search: "",
      menuDate: false,
      loading: true,
      // variables para manejo de snackbar
      snackbar: false,
      mensaje: "",
      // Encabezados de la tabla
      headers: [
        { id: "headerReservationId", text: "Id", value: "reservationId" },
        { id: "headerCarName", text: "Auto", value: "name" },
        //{ id:'', text: "tipo de atributo", value: "attributeType" },
        {
          id: "headerUser",
          text: "Usuario",
          value: "user",
          sortable: true
        },
        {
          id: "headerCC",
          text: "CC",
          value: "centroCostos",
          sortable: true
        },
        {
          id: "headerApprover",
          text: "Aprobador",
          value: "approver",
          sortable: false
        },
        {
          id: "headerStatus",
          text: "Estado",
          value: "status",
          sortable: false
        },
        {
          id: "headerStartDate",
          text: "Fecha de inicio",
          value: "startDate",
          sortable: false
        },
        {
          id: "headerEndDate",
          text: "Fecha de fin",
          value: "endDate",
          sortable: false
        }
      ],
      // App data
      requests: [],
      dates: ['2024-02-21', '2024-02-27'],
    };
  },
  created() {
    this.$i18n.locale = this.locale;
    // Obtenemos la lista de atributos
    // this.loadData(1704693600, 1705125600);
    // Get current date
    let currentDate = new Date();
    // Get date 7 days ago
    let sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(currentDate.getDate() - 7);
    this.dates = [this.formatDate(sevenDaysAgo), this.formatDate(currentDate)];
    //inicializamos encabezados de la tabla
    this.updateHeadersLocale();
  },
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
    dateRangeText () {
      return this.dates.join(' | ')
    },
    reportLables(){
      return {
        reservationId: {title: this.$t('headerReservationId')},
        name: {title: this.$t('headerCarName')},
        user: {title: this.$t('headerUser')},
        centroCostos: {title: this.$t('headerCC')},
        approver: {title: this.$t('headerApprover')},
        status: {title: this.$t('headerStatus')},
        startDate: {title: this.$t('headerStartDate')},
        endDate: {title: this.$t('headerEndDate')},
      }
    },
    formatDataRequests(){
      return this.requests.map(item => {
        return {
          reservationId: item.reservationId,
          name: item.name,
          user: item.user,
          centroCostos: item.centroCostos,
          approver: item.approver,
          status: this.getStatus(item.status),
          startDate: this.formatDateTime(new Date(item.startDate * 1000)),
          endDate: this.formatDateTime(new Date(item.endDate * 1000)),
        };
      });
    },
    UNIXDates(){
      return this.dates.map(dateSring => {
        let date = new Date(dateSring);
        date.setHours(date.getHours() + 6);
        return new Date(date).getTime() / 1000;
      }).sort((a, b) => a - b);
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    },
    UNIXDates(UNIXDates){
      console.log("UNIXDates: ", UNIXDates);
      console.log("dates: ", this.dates);
      if(UNIXDates.length > 1){
        this.requests = [];
        // Llamamos a la funcion que consulta las solicitudes de auto
        // Se suma un dia a la fecha final para que se incluyan las solicitudes del ultimo dia
        this.loadData(UNIXDates[0], UNIXDates[1]+86400);
      }
    }
  },
  methods: {
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map(header => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    // Consulta las solicitudes de auto en las fechas seleccionadas
    loadData(startDate, endDate) {
      //** console.log("invocaion loadData");
      let params = {
        startDate: startDate,
        endDate: endDate
      };
      this.$GET("/api/request/all/{{startDate}}/{{endDate}}", params)
        .then(requests => {
          this.requests = requests
          console.log("requests: ", this.requests);
        })
        .catch(() => { 
          //** console.log(e)
        });
    },
    getStatus(status){
      switch (status) {
        case 1:
          return "Pendiente";
        case 2:
          return "Aprobado";
        case 3:
          return "Cancelado";
        case 4:
          return "Entregado";
        case 5:
          return "Devuelto";
        default:
          return "Devuelto";
      }
    },
    formatDateTime(date){
      let options = { 
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };
      return date.toLocaleString("es-MX", options)
    },
    formatDate(date) {
      let year = date.getFullYear();
      let month = (1 + date.getMonth()).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');

      return year + '-' + month + '-' + day;
    }
  }
};
</script>